import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { PaymentAccount } from 'Src/models/paymentAccount';
import { superAdminGet } from './api';

export interface SuperAdminPaymentAccountsFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminPaymentAccountsFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'name ASC'
};

function buildFilter(filter: SuperAdminPaymentAccountsFilter = DEFAULT_FILTER): SuperAdminPaymentAccountsFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminSchoolPaymentAccounts(
  schoolId: string,
  filter: SuperAdminPaymentAccountsFilter = DEFAULT_FILTER
): Promise<PaymentAccount[]> {
  return superAdminGet<PaymentAccount[]>(`/schools/${schoolId}/payments/accounts`, {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminSchoolPaymentAccounts(schoolId: string, where?: any): Promise<PaymentAccount[]> {
  return superAdminGet<PaymentAccount[]>(`/schools/${schoolId}/payments/accounts`, {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminSchoolPaymentAccountsCount(schoolId: string, where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>(`/schools/${schoolId}/payments/accounts/count`, config);
}

export function getSuperAdminSchoolPaymentAccount(schoolId: string, accountId: string): Promise<PaymentAccount> {
  return superAdminGet<PaymentAccount>(`/schools/${schoolId}/payments/accounts/${accountId}`);
}
